import React, {useContext} from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import { Alert, Button, Form, Row, Col } from "react-bootstrap";
import { Eye, EyeOff } from 'react-feather';
import useAuth from "../../hooks/useAuth";
import NotyfContext from "../../contexts/NotyfContext";

function ResetPassword() {
  const navigate = useNavigate();
  const notyf = useContext(NotyfContext);
  const { confirmResetPassword } = useAuth();
  const {resetId} = useParams()
  const [showPassword, setShowPassword] = React.useState({
    password: false,
    confirmPassword: false,
  });

  return (
    <Formik
      initialValues={{
        id: resetId,
        password: "",
        confirmPassword: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string().min(6, 'Must be at least 6 characters')
        .max(255)
        .required('Password is Required')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ),
        confirmPassword: Yup.string()
          .min(6, 'Must be at least 6 characters')
          .max(255)
          .required('Confirm password required')
          .oneOf([Yup.ref('password'), null], 'Passwords must match'),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          const {msg} = await confirmResetPassword(values.id, values.password)
          notyf.open({
            type: 'success',
            message: msg,
            duration: '3000',
            ripple: false,
            dismissible: false,
            position: {
              x: 'right',
              y: 'top',
            },
          });
          setTimeout(() => {
            navigate("/");
          }, 3000);
          
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert className="my-3" variant="danger">
              <div className="alert-message">{errors.submit}</div>
            </Alert>
          )}
          <Row>
            <Form.Group as={Col} className='col-12 mb-3'>
              <Form.Label className='text-light-gray form-label'>Create Password</Form.Label>
              <div className='position-relative'>
                <Form.Control size='lg' type={showPassword.password ? 'text' : 'password'} name='password' placeholder='Password' value={values.password} isInvalid={Boolean(touched.password && errors.password)} onBlur={handleBlur} onChange={handleChange} />
                <span className='position-absolute top-50 end-0 translate-middle-y text-dark-blue' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => setShowPassword({...showPassword, password: !showPassword.password})}>
                  {showPassword.password ? <EyeOff /> : <Eye />}
                </span>
              </div>
              {!!touched.password && <Form.Control.Feedback type='invalid'>{errors.password}</Form.Control.Feedback>}
            </Form.Group>
            <Form.Group as={Col} className='col-12 mb-3'>
              <Form.Label className='text-light-gray form-label'>Verify Password</Form.Label>
              <div className='position-relative'>
                <Form.Control size='lg' type={showPassword.confirmPassword ? 'text' : 'password'} name='confirmPassword' placeholder='Confirm Password' value={values.confirmPassword} isInvalid={Boolean(touched.confirmPassword && errors.confirmPassword)} onBlur={handleBlur} onChange={handleChange} />
                <span className='position-absolute top-50 end-0 translate-middle-y text-dark-blue' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => setShowPassword({...showPassword, confirmPassword: !showPassword.confirmPassword})}>
                  {showPassword.confirmPassword ? <EyeOff /> : <Eye />}
                </span>
              </div>
              {!!touched.confirmPassword && <Form.Control.Feedback type='invalid'>{errors.confirmPassword}</Form.Control.Feedback>}
            </Form.Group>
          </Row>
          <div className="text-center mt-3">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={isSubmitting}
            >
              Reset password
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default ResetPassword;
